import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../auth/useAuth';
import { createApiClient } from '../client';

export interface AiModelDto {
  provider: string;
  model: string;
  displayName: string;
  isDefault: boolean;
}

export function useAiModels() {
  const { getToken } = useAuth();
  return useQuery<AiModelDto[]>({
    queryKey: ['ai-models'],
    queryFn: async () => {
      const client = createApiClient(getToken);
      const response = await client
        .get('api/v2/ai/models')
        .json<{ data: AiModelDto[] }>();
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // models don't change often
  });
}
